import React from "react"
import Logo from "../assetts/logo"

export default function PageNotFound({ onClick }: { onClick: () => void }) {
  return (
    <div className="bg-stone-light">
      <div className=" max-w-page mx-auto">
        <header>
          <div className="flex items-center pr-4 ">
            <nav>
              <a href="/" aria-label="Flyp Logo Home">
                <Logo />
              </a>
            </nav>
          </div>
        </header>
        <main className="relative min-h-page grid md:place-items-center">
          <div className="mt-8 lg:mt-0 mb-[120px] flex flex-col items-center gap-10">
            <div className="marker bg-brick text-white heading tracking-widest text-[1.5rem]  md:text-[2rem]">
              <span className="px-1">404</span>
            </div>
            <h1
              className="text-center text-[2rem] sm:text-[3rem] md:text-[4rem]"
              data-cy={"page-not-found"}
            >
              Page not Found
            </h1>
            <p className=" text-xl text-center">
              Woops ... how did you get here?
            </p>
            <button
              className=" button secondary"
              onClick={onClick}
              data-cy={"page-not-found-btn"}
            >
              Back to home
            </button>
          </div>
        </main>
      </div>
    </div>
  )
}
